import React from 'react';
import { MDBInput } from "mdb-react-ui-kit";

// reactstrap components
import { Col, Card, CardBody, Row, Form, Label, FormGroup , Input , UncontrolledTooltip , Button  } from "reactstrap";


const createtemplate = () => {
  return (
    <>
      <div className='content' >
      <Card>
        <CardBody>
        <Form action="#">
          <Row>
          <Col className="mt-4" md="3">
      <MDBInput
                    label="Callflow Name"
                    type="text"
                    name="name"
                    value={""}
                  />
        </Col>
        <Col md="3" sm='3'>
                   
                    <Label >Bulk Upload (<b>Upload Excel and CSV File</b>)</Label>
                    
                      <FormGroup>
                        <Input placeholder="placeholder" accept=".xlsx, .xls, .csv"  type="file" style={{"opacity" : "1", "position": "initial", "border" : "solid 1px #eee"}}/>
                      </FormGroup>
                     
                  
                    </Col>
                    <Col md='3' sm='3'>
                  <Button 
                    color="primary "
                    className="mt-4 btn btn-icon animation-on-hover"
                    id="tooltipsubmit"
                    type="button"
                  
                  ><i className="tim-icons icon-double-right"  /></Button>
                  <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltipsubmit"
                >
                  Submit
                </UncontrolledTooltip>
                  </Col>
          </Row>
        </Form>
      
        </CardBody>
        </Card>
      </div>
    </>
  )
}

export default createtemplate
